import React, { useEffect, useState } from 'react';
import { Container, Typography, Box, Paper, Divider } from '@mui/material';
import { getSelfInfo } from '../services/api';
import EmailIcon from '@mui/icons-material/Email';
import PersonIcon from '@mui/icons-material/Person';
import GroupIcon from '@mui/icons-material/Group';
import StarIcon from '@mui/icons-material/Star';

const Dashboard = () => {
  const [userInfo, setUserInfo] = useState(null);

  useEffect(() => {
    const fetchUserInfo = async () => {
      try {
        const response = await getSelfInfo();
        setUserInfo(response.data);
      } catch (error) {
        console.error('Error fetching user info:', error);
      }
    };

    fetchUserInfo();
  }, []);

  return (
    <Container maxWidth="md" sx={{minHeight: '100vh', py: 4 }}>
      <Box sx={{ my: 4 }}>
        <Typography variant="h4" component="h1" gutterBottom sx={{ fontWeight: 'bold', color: 'primary.main' }}>
          Dashboard
        </Typography>
        {userInfo ? (
          <Paper elevation={5} sx={{ p: 3, borderRadius: 2 }}>
            <Typography variant="h6" sx={{ fontWeight: 'bold' }}>User Information</Typography>
            <Divider sx={{ my: 2 }} />
            <Box sx={{ display: 'flex', alignItems: 'center', mb: 2 }}>
              <EmailIcon sx={{ mr: 1, color: '#1976d2' }} />
              <Typography>Email: {userInfo.email}</Typography>
            </Box>
            <Box sx={{ display: 'flex', alignItems: 'center', mb: 2 }}>
              <PersonIcon sx={{ mr: 1, color: '#1976d2' }} />
              <Typography>Username: {userInfo.username}</Typography>
            </Box>
            <Box sx={{ display: 'flex', alignItems: 'center', mb: 2 }}>
              <GroupIcon sx={{ mr: 1, color: '#1976d2' }} />
              <Typography>User Group: {userInfo.user_group}</Typography>
            </Box>
            <Box sx={{ display: 'flex', alignItems: 'center', mb: 2 }}>
              <StarIcon sx={{ mr: 1, color: '#1976d2' }} />
              <Typography>VIP Expires At: {userInfo.vip_expires_at || 'N/A'}</Typography>
            </Box>
          </Paper>
        ) : (
          <Typography>Loading user information...</Typography>
        )}
      </Box>
    </Container>
  );
};

export default Dashboard;
